import { Component, Vue, Prop } from 'vue-property-decorator';
import WithRender from './Credit.html';
import config from "@/settings/config.js";
import { PaymentDto } from '@/Dtos/PaymentDto';
import _axios from '@/services/axios';
import { mapGetters } from 'vuex';
import { CartLine, PaymentGateWay } from '@/types/CartTypes';

@WithRender
@Component({
  computed: {
    ...mapGetters("shoppingCart",
      { payment: "getPaymentGateWayDto" }),
    ...mapGetters("originatorStore", {
      originator: "getOriginator",
      currency: "getWalletCurrency"
    }),
  }
})
export default class Credit extends Vue {
  currency!: string;
  balance = 0;
  //currency: String = "";
  payment!: PaymentGateWay;
  isLoading = true;
  paymentDto = {} as PaymentDto;

  mounted() {
    this.getCreditBalance();
  }
  getCreditBalance(): void {
    _axios.get(config.credits + "Currency="+ this.currency)
      .then(response => {
        this.balance = response.data.balance;
      })
      .catch(err => { console.error(err); })
      .finally(() => this.isLoading = false);
  }

  makePayment(): void {
    this.paymentDto.Amount = this.payment.totalAmount;
    this.paymentDto.Currency = this.currency;
    this.paymentDto.Description = this.payment.itemDescription;
    this.paymentDto.ItemName = this.payment.itemName;
    this.paymentDto.ReferenceId = this.payment.mPaymentId;
    this.paymentDto.Signature = this.payment.signature;
    this.paymentDto.PaymentProviderServiceFeeTotal = this.payment.paymentProviderServiceFeeTotal;
    this.isLoading = true;

    _axios.post(config.walletWithdrawal, this.paymentDto)
      .then(response => {
        console.log("done processing payement");
        window.location.href = "/callback?page=success";
      })
      .catch(err => { console.error(err); });
  }

  get AllowPayment(): boolean {
    console.log(this.payment)
    let check = this.balance - this.payment.totalAmount;
    return check >= 0
  }
}
